"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSub = exports.StyledSup = exports.StyledSpan = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const themed_text_1 = require("../../themed-text");
const setStyles = (0, styled_components_1.css) `
  padding: 0 0 0 0px;
  width: 100%;
`;
const setSupSubStyles = (0, styled_components_1.css) `
  top = -.5em;
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
`;
exports.StyledSpan = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  white-space: pre-line;
  ${setStyles}
`;
exports.StyledSup = styled_components_1.default.sup `
  ${setSupSubStyles};
`;
exports.StyledSub = styled_components_1.default.sub `
  ${setSupSubStyles};
`;
